import React from "react";
import { useNavigate } from 'react-router-dom';
import "./createSuccessfulChannel.css";

const CreateSuccessfulChannel = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className=" successful_create_transprant_body ">
        <div className=" p-2 successful_create_container shadow">
          <img src="images/Ellipse 208.svg" alt="" />
          <span className=" my-4 successfully_create_message">
            You have successfully created the channel
          </span>
          {/* <Link to={`/TotalCommuPost/${}}`} className="link"> */}
          <button
            onClick={() => navigate("/TotalCommuPost")}
            className="btn btn-danger px-4 py-2 successfull_create_okay_btn"
          >
            Okay
          </button>
          {/* </Link> */}
        </div>
      </div>
    </>
  );
};

export default CreateSuccessfulChannel;
